import { useState } from 'react';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Panel } from 'foundations-components/transitional/components/Panel';
import { View } from 'foundations-components/transitional/components/View';
import { LowLevelAuthFlowView } from '../shared/components/LowLevelAuthFlowView';
import { useAuthConfigFetch } from '../shared/hooks/useAuthConfigFetch';
import { AuthConfigLoadingState, AuthConfigFetchFailureState } from '../shared/components/AuthConfigStates';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
// Re-export for consumers that imported from here (backward compat)
export { AuthConfigLoadingState, AuthConfigFetchFailureState };
export function UnifiedAuthView(props) {
  var _modeSettings$width, _modeSettings$use;
  const {
    isReauth = false,
    portalId,
    accountId,
    appName,
    onComplete,
    onCancel = () => {},
    fetchAuthConfig,
    useIntroScreen,
    useSuccessScreen,
    onAuthError,
    debug = false
  } = props;
  // `mode`/`modeSettings` are read from `props` directly (not destructured
  // above) so the mode-settings correlation in UnifiedAuthViewModeProps stays
  // narrowable below — TS doesn't carry that correlation across independently
  // destructured bindings.
  const isModal = props.mode !== 'inline';
  const configFetchState = useAuthConfigFetch(fetchAuthConfig);
  const [isAuthInProgress, setIsAuthInProgress] = useState(false);
  const children = /*#__PURE__*/_jsx(_Fragment, {
    children: configFetchState.status === 'pending' ? /*#__PURE__*/_jsx(AuthConfigLoadingState, {
      isModal: isModal,
      onCancel: onCancel
    }) : configFetchState.status === 'succeeded' ? /*#__PURE__*/_jsx(LowLevelAuthFlowView, {
      isModal: isModal,
      isReauth: isReauth,
      portalId: portalId,
      authConfig: configFetchState.config,
      onComplete: payload => onComplete === null || onComplete === void 0 ? void 0 : onComplete(payload),
      onCancel: onCancel,
      accountId: accountId,
      useIntroScreen: useIntroScreen,
      useSuccessScreen: useSuccessScreen,
      onError: onAuthError,
      onAuthInProgressChange: setIsAuthInProgress,
      debug: debug
    }) : /*#__PURE__*/_jsx(AuthConfigFetchFailureState, {
      isModal: isModal,
      onClose: onCancel,
      appName: appName,
      isReauth: isReauth,
      error: configFetchState.err
    })
  });
  if (!isModal) {
    return /*#__PURE__*/_jsx(View, {
      "data-test-id": "unified-auth-form",
      children: children
    });
  }
  if (props.mode === 'panel') {
    const {
      modeSettings
    } = props;
    return /*#__PURE__*/_jsx(Panel, {
      "data-test-id": "unified-auth-panel",
      align: modeSettings === null || modeSettings === void 0 ? void 0 : modeSettings.align,
      width: modeSettings === null || modeSettings === void 0 ? void 0 : modeSettings.width,
      maxWidth: modeSettings === null || modeSettings === void 0 ? void 0 : modeSettings.maxWidth,
      topOffset: modeSettings === null || modeSettings === void 0 ? void 0 : modeSettings.topOffset,
      children: children
    });
  }
  const {
    modeSettings
  } = props;
  return /*#__PURE__*/_jsx(Modal, {
    "data-test-id": "unified-auth-modal",
    width: (_modeSettings$width = modeSettings === null || modeSettings === void 0 ? void 0 : modeSettings.width) !== null && _modeSettings$width !== void 0 ? _modeSettings$width : 550,
    size: modeSettings === null || modeSettings === void 0 ? void 0 : modeSettings.size,
    use: (_modeSettings$use = modeSettings === null || modeSettings === void 0 ? void 0 : modeSettings.use) !== null && _modeSettings$use !== void 0 ? _modeSettings$use : 'default',
    onEsc: isAuthInProgress ? () => {} : undefined,
    children: children
  });
}